// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import firebase from 'firebase/compat/app';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { getAuth } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyA2oHx3WJY3SDVO_4dJPEqmhyu2oeYLgUM',
  authDomain: 'layoff-tracker-1a738.firebaseapp.com',
  projectId: 'layoff-tracker-1a738',
  storageBucket: 'layoff-tracker-1a738.appspot.com',
  messagingSenderId: '896390703319',
  appId: '1:896390703319:web:f21d64bac9957cc1616892',
  measurementId: 'G-CF099CXBGD',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const db = getFirestore(app);

const uiConfig = ({
  signInSuccessUrl: '/',
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
  tosUrl: '/terms-of-service', // This doesn't exist yet
});

// This must run before any other firebase functions
firebase.initializeApp(firebaseConfig);

// This sets up firebaseui
const ui = new firebaseui.auth.AuthUI(firebase.auth());

// This adds firebaseui to the page
// It does everything else on its own
const startFirebaseUI = function firebasUI(elementId) {
  ui.start(elementId, uiConfig);
};

// firebase.auth().onAuthStateChanged((user) => {
//   // if user isn't null then we logged in
//   console.log("------>",user);
//   if (user) {
//     // login
//   } else {
//     // logout
//   }
// })

// const auth = getAuth(firebaseConfig);
// onAuthStateChanged(auth, user => {
//   // Check for user status
//   console.log(user);
// });

export { db };
export { startFirebaseUI };
export const auth = getAuth();

// export {firebaseConfig }
